import gql from 'graphql-tag';

// `$avatar` e o escalar Upload do apollo_upload_server: o arquivo vai no mesmo
// multipart do cadastro. A versao anterior declarava o mesmo tipo, mas ele nao
// existia no GlobalSchema e o servidor esperava `avatarUrl` — a validacao
// estatica derrubava todo submit, com ou sem foto.
export const CREATE_ACCOUNT_MUTATION = gql`
  mutation createAccount(
    $avatar: Upload
    $name: String!
    $lastName: String!
    $email: String!
    $phone: String!
    $password: String!
    $atuation_type: String!
    $category: String
    $subcategory: String
    $cref: String
    $cpf: String
    $zipcode: String
    $street: String
    $number: String
    $complement: String
    $neighborhood: String
    $city: String
    $state: String
    $latitude: Float
    $longitude: Float
  ) {
    createAccount(
      input: {
        avatar: $avatar
        name: $name
        lastName: $lastName
        email: $email
        password: $password
        atuationType: $atuation_type
        category: $category
        subcategory: $subcategory
        cref: $cref
        cpf: $cpf
        phone: $phone
        zipcode: $zipcode
        street: $street
        number: $number
        complement: $complement
        neighborhood: $neighborhood
        city: $city
        state: $state
        latitude: $latitude
        longitude: $longitude
      }
    ) {
      account {
        id
        name
        code
        owner {
          id
          name
          lastName
          email
          phone
          token
        }
      }
    }
  }
`;

export default CREATE_ACCOUNT_MUTATION;
